$(document).on('click', '.js-load-more-omnia-partners', function(event) {
  event.preventDefault();
  var $this = $(this);

  $.get('/ajax/omnia-partners/?ajax=1', function(data) {
    $('.js-grid').append(data);
    $this.parent('div').remove();
  });
});
